const styles = () => ({
  radioRoot: {
    margin: '0px !important',
    whiteSpace: 'nowrap',
  },
})

export default styles
